<template>

</template>

<script>
export default {
  data () {
    return {
    }
  },
  created () {
    var acccessID = this.getSessionItem('id_token')
    var accessToken = this.getSessionItem('access_token')

    var self = this
    self.$geb.emit({id: 'preloader', eventData: true})
    self.flyPost('logout', {
      access_id: acccessID,
      access_token: accessToken
    })
    .then(function (response) {
      self.$geb.emit({id: 'preloader', eventData: false})
      self.removeSessionItem('id_token')
      self.removeSessionItem('access_token')
      self.removeSessionItem('selected_edc')
      self.removeSessionItem('selected_service')
      self.removeSessionItem('selected_counter')
      self.getEDCBankList()

      self.$router.push('/')
    })
    .catch(function (response) {
      self.$geb.emit({id: 'preloader', eventData: false})
      self.errorMessage(response)
    })
  },
  methods: {
    getEDCBankList () {
      var self = this
      self.flyGetSession('frontdesk/get_edc_bank').then(function (response) {
        if (response.data.response_code === 1) {
          var edcBankList = response.data.data

          for (var index in edcBankList) {
            self.removeSessionItem('edc_bank_' + edcBankList[index].id)
          }
        } else {
          /*
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
          */
        }
      }).catch(function (response) {
        self.errorMessage(response)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/panel/Logout.vue